import {
  MODAL_NAMES,
  useOrganizationModalsContext,
} from '../../contexts/OrganizationModalsContext';
import { AddToProjectModal } from '../Modals/AddToProjectModal';
import { EditMemberModal } from '../Modals/EditMemberModal';
import { RemoveFromProjectModal } from '../Modals/RemoveFromProjectModal';
import { ResetMultifactorModal } from '../Modals/ResetMultifactorModal';
import { ResetPasswordModal } from '../Modals/ResetPasswordModal';
import { RevokeAccessModal } from '../Modals/RevokeAccessModal';
import { MembershipModal } from '../Modals/MembershipModal';

export const Modals = () => {
  const { modalState } = useOrganizationModalsContext();

  return (
    <>
      {modalState?.name === MODAL_NAMES.RESET_PASSWORD && <ResetPasswordModal />}
      {modalState?.name === MODAL_NAMES.REVOKE_ACCESS && <RevokeAccessModal rerouteOnSuccess />}
      {modalState?.name === MODAL_NAMES.UPDATE_MEMBER && <EditMemberModal />}
      {modalState?.name === MODAL_NAMES.REMOVE_FROM_PROJECT && <RemoveFromProjectModal />}
      {modalState?.name === MODAL_NAMES.ADD_TO_PROJECT && <AddToProjectModal />}
      {modalState?.name === MODAL_NAMES.MEMBERSHIP_ROLE && <MembershipModal />}
      {modalState?.name === MODAL_NAMES.RESET_MFA && <ResetMultifactorModal />}
    </>
  );
};
